import { render, staticRenderFns } from "./BaseInfoPanelBook.vue?vue&type=template&id=660c7f1e&scoped=true"
import script from "./BaseInfoPanelBook.vue?vue&type=script&lang=ts"
export * from "./BaseInfoPanelBook.vue?vue&type=script&lang=ts"
import style0 from "./BaseInfoPanelBook.vue?vue&type=style&index=0&id=660c7f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660c7f1e",
  null
  
)

export default component.exports